import axios from 'axios';
import { z } from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';
import EntityType from 'types/ShoppingCart/EntityType';

export type Request = {
	entityId: string;
	entityType: EntityType;
	quantity: number;
	erpRecipeIds: string[];
};

const TranslationsSchema = z.record(z.string());

const AppearanceSchema = z.object({
	entityId: z.string().uuid(),
	entityType: z.enum([EntityType.MENU, EntityType.RECIPE, EntityType.MENUPLAN]),
	nameTranslation: TranslationsSchema,
	quantity: z.number(),
});

const ResponseDataSchema = z.object({
	appearances: z.array(AppearanceSchema),
});

export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(id: string, request: Request): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/ShoppingCart/AddToShoppingCart/${id}`;
	return (await axios.post(url, request).toOptionalFiltered(validator)).map((x) => x.data);
}
